// extracted by mini-css-extract-plugin
module.exports = {"side-bar-footer":"MenuSideBar_side-bar-footer__2Zqsm","sideBarFooter":"MenuSideBar_side-bar-footer__2Zqsm"};